export enum ReactionSubjectType {
  Review = 'Review',
  ReviewAnswer = 'ReviewAnswer',
}

export enum ReactionType {
  Dislike = 'dislike',
  Like = 'like',
  Report = 'report',
}

export interface Reaction {
  comment?: string;
  createdAt: Date;
  deletedAt?: Date;
  id: number;
  reactionType: ReactionType;
  subjectId: number;
  subjectType: ReactionSubjectType;
  updatedAt: Date;
  userId: number;
}
